// @flow

import * as React from 'react';

import clsx from 'clsx';
import { OctagonAlert } from 'lucide-react';

import { selectCartUUID } from '@gandi/cart';
import type { ApplicationSummary } from '@gandi/redux-resource-simplehosting';
import { useTranslator } from '@gandi/translate';
import { Base, Button, Checkbox, useDisclosure } from '@gandi/ui';

import type { ExtendedSuggestion } from 'src/DomainCreate/types';
import { useAppSelector } from 'src/hooks/useAppSelector';
import { useRequireAuthNavigate } from 'src/hooks/useRequireAuthNavigate';

import DomainIntro from './DomainIntro';

import DomainSearch from './DomainSearch';

import styles from './Domains.scss';

export type OwnProps = {
  childRef: React.ElementRef<any>,
  application?: ApplicationSummary,
  handleChooseDomain: (value: ExtendedSuggestion) => Promise<void>,
};

export type Props = {
  ...OwnProps,
};

export function Domains({
  childRef,
  application,
  handleChooseDomain,
}: Props): React.MixedElement {
  return (
    <div
      className={styles.whDomainsContainer}
      ref={childRef}
      id="choose-a-domain"
    >
      <Base marginBottom="base">
        <DomainIntro application={application} />
      </Base>

      <Base marginBottom="base">
        <DomainSearch handleChooseDomain={handleChooseDomain} />
      </Base>

      <SkipDomain />
    </div>
  );
}

function SkipDomain() {
  const { __ } = useTranslator();

  const { toggle, triggerProps, contentProps } = useDisclosure();
  const { onClick, ...checkboxProps } = triggerProps;

  const cartId = useAppSelector(selectCartUUID);

  const navigateToCartOverview = useRequireAuthNavigate(`/cart/${cartId}`);

  if (!cartId) {
    return null;
  }

  const content = __('or');

  return (
    <Base className={clsx(styles.continue, 'wrapper-md')}>
      <hr data-content={content} />
      <div>
        <Checkbox onChange={toggle} name="alreadyName" {...checkboxProps}>
          {__('Do you already have a domain name for your hosting?')}
        </Checkbox>

        <Base {...contentProps}>
          <div className={styles.content}>
            <Base color="light" margin="none" tagName="p">
              {__(
                'You can use one of your existing Gandi domains or even a domain managed by another registrar. Configuration of hosting and domain will be done after purchase.',
              )}
            </Base>
            <div className={styles.info}>
              <OctagonAlert />

              {__(
                'By using your own domain name, you will not be able to benefit from the free domain name and mailbox offer.',
              )}
            </div>
            <Base flexAlignSelfEnd>
              <Button
                iconAfter="arrowRight"
                onClick={navigateToCartOverview}
                type="button"
                small
              >
                {__('Continue')}
              </Button>
            </Base>
          </div>
        </Base>
      </div>
    </Base>
  );
}
